import c from "classnames/bind";

import styles from "./radio-card-group.module.scss";
export const cx = c.bind(styles);
